module.exports = __webpack_public_path__ + "static/notthinkablelogo-3d2b9807990de500176a332fa7c072d0.png";